import * as React from 'react';

const BgOrbitalPattern = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 361 201"
    fill="none">
    <mask
      id="a"
      width={361}
      height={201}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#D9D9D9"
        d="M354.16.8h-348a6 6 0 0 0-6 6v188.001a6 6 0 0 0 6 6h348a6 6 0 0 0 6-6v-188a6 6 0 0 0-6-6Z"
      />
    </mask>
    <g stroke="#fff" strokeOpacity={0.22} mask="url(#a)">
      <path
        strokeWidth={0.229}
        d="M213.768 193.621c67.852-24.696 107.842-85.971 89.32-136.86-18.522-50.89-88.543-72.123-156.395-47.427-67.853 24.697-107.843 85.97-89.32 136.86 18.522 50.89 88.542 72.123 156.395 47.427Z"
      />
      <path
        strokeWidth={0.233}
        d="M211.602 196.336c69.853-23.101 112.435-84.299 95.108-136.69-17.326-52.389-87.999-76.132-157.852-53.03-69.853 23.102-112.434 84.3-95.108 136.689 17.326 52.39 87.999 76.133 157.852 53.031Z"
      />
      <path
        strokeWidth={0.238}
        d="M209.306 199.013c71.818-21.41 117.021-82.431 100.963-136.294-16.057-53.863-87.294-80.172-159.111-58.762C79.34 25.367 34.138 86.387 50.195 140.25c16.057 53.863 87.294 80.172 159.111 58.762Z"
      />
      <path
        strokeWidth={0.242}
        d="M206.877 201.631c73.742-19.622 121.592-80.363 106.876-135.67-14.716-55.306-86.425-84.235-160.167-64.613C79.843 20.968 31.993 81.71 46.709 137.017c14.716 55.306 86.426 84.235 160.168 64.614Z"
      />
      <path
        strokeWidth={0.246}
        d="M204.317 204.181c75.622-17.737 126.143-78.094 112.84-134.811-13.303-56.717-85.392-88.317-161.014-70.58C80.52 16.528 30 76.884 43.303 133.601c13.303 56.717 85.391 88.317 161.014 70.58Z"
      />
      <path
        strokeWidth={0.251}
        d="M201.631 206.666c77.455-15.758 130.663-75.625 118.845-133.717-11.819-58.09-84.19-92.408-161.645-76.65C81.376 12.057 28.167 71.924 39.986 130.016c11.819 58.091 84.189 92.409 161.645 76.65Z"
      />
      <path
        strokeWidth={0.255}
        d="M198.816 209.082c79.236-13.687 135.148-72.956 124.883-132.383-10.265-59.427-82.819-96.507-162.055-82.82C82.409 7.565 26.497 66.835 36.762 126.262c10.264 59.426 82.819 96.506 162.054 82.82Z"
      />
      <path
        strokeWidth={0.259}
        d="M195.879 211.426c80.96-11.522 139.585-70.086 130.943-130.806-8.641-60.72-81.278-100.603-162.238-89.08C83.624 3.061 24.999 61.625 33.64 122.345c8.642 60.72 81.279 100.602 162.239 89.08Z"
      />
      <path
        strokeWidth={0.264}
        d="M192.815 213.689c82.625-9.268 143.971-67.016 137.02-128.984-6.951-61.969-79.566-104.691-162.191-95.423-82.625 9.267-143.97 67.016-137.02 128.984 6.952 61.969 79.567 104.691 162.191 95.423Z"
      />
      <path
        strokeWidth={0.268}
        d="M189.633 215.866c84.226-6.925 148.294-63.747 143.1-126.916-5.193-63.17-77.681-108.764-161.907-101.84-84.225 6.925-148.294 63.747-143.1 126.916 5.193 63.169 77.682 108.765 161.907 101.84Z"
      />
      <path
        strokeWidth={0.272}
        d="M186.335 217.947c85.759-4.495 152.547-60.279 149.177-124.599-3.371-64.319-75.625-112.816-161.384-108.322C88.369-10.479 21.58 45.306 24.951 109.624c3.37 64.319 75.625 112.817 161.384 108.323Z"
      />
      <path
        strokeWidth={0.277}
        d="M182.918 219.929c87.221-1.979 156.724-56.614 155.24-122.03-1.485-65.416-73.395-116.841-160.616-114.862-87.221 1.98-156.724 56.614-155.24 122.03 1.485 65.416 73.395 116.841 160.616 114.862Z"
      />
      <path
        strokeWidth={0.281}
        d="M179.389 221.819c88.609.618 160.816-52.754 161.28-119.21.464-66.456-70.991-120.831-159.599-121.45-88.609-.618-160.816 52.754-161.28 119.21-.464 66.456 70.991 120.831 159.599 121.45Z"
      />
      <path
        strokeWidth={0.285}
        d="M175.754 223.59c89.917 3.297 164.814-48.699 167.287-116.137 2.472-67.438-68.415-124.78-158.332-128.077C94.792-23.92 19.895 28.076 17.422 95.513c-2.473 67.438 68.415 124.78 158.332 128.077Z"
      />
      <path
        strokeWidth={0.29}
        d="M172.011 225.253c91.144 6.053 168.711-44.454 173.251-112.812 4.54-68.357-65.665-128.68-156.809-134.734C97.309-28.346 19.743 22.161 15.202 90.52c-4.54 68.357 65.665 128.68 156.809 134.734Z"
      />
      <path
        strokeWidth={0.294}
        d="M168.164 226.812c92.284 8.886 172.499-40.019 179.163-109.233 6.665-69.213-62.744-132.525-155.029-141.411C100.014-32.718 19.799 16.187 13.135 85.4c-6.664 69.214 62.744 132.526 155.029 141.412Z"
      />
      <path
        strokeWidth={0.298}
        d="M164.217 228.23c93.337 11.791 176.17-35.399 185.013-105.401 8.844-70.002-59.652-136.31-152.988-148.1-93.337-11.791-176.17 35.398-185.013 105.4C2.386 150.132 70.88 216.44 164.217 228.23Z"
      />
      <path
        strokeWidth={0.303}
        d="M160.179 229.532c94.296 14.766 179.716-30.595 190.791-101.317 11.074-70.722-56.39-140.024-150.686-154.79C105.988-41.343 20.568 4.018 9.494 74.74c-11.076 70.722 56.389 140.024 150.685 154.791Z"
      />
      <path
        strokeWidth={0.307}
        d="M156.049 230.707c95.16 17.809 183.13-25.611 196.487-96.981 13.356-71.37-52.959-143.664-148.119-161.473C109.257-45.555 21.287-2.135 7.93 69.235-5.426 140.605 60.89 212.899 156.05 230.707Z"
      />
      <path
        strokeWidth={0.311}
        d="M151.829 231.751c95.926 20.915 186.405-20.452 202.092-92.397C369.607 67.41 304.56-7.867 208.635-28.782 112.709-49.697 22.23-8.33 6.544 63.614c-15.687 71.944 49.36 147.222 145.285 168.137Z"
      />
      <path
        strokeWidth={0.316}
        d="M147.527 232.647c96.589 24.083 189.532-15.12 207.594-87.562 18.061-72.442-45.598-150.69-142.187-174.773C116.345-53.77 23.402-14.568 5.34 57.875c-18.062 72.442 45.597 150.69 142.187 174.772Z"
      />
      <path
        strokeWidth={0.32}
        d="M143.148 233.415c97.148 27.307 192.505-9.622 212.985-82.483 20.48-72.861-41.671-154.064-138.819-181.37-97.149-27.308-192.505 9.62-212.986 82.482-20.48 72.861 41.671 154.064 138.82 181.371Z"
      />
      <path
        strokeWidth={0.324}
        d="M138.695 234.023c97.6 30.586 195.316-3.959 218.255-77.159 22.94-73.2-37.584-157.335-135.184-187.92C124.166-61.644 26.45-27.098 3.51 46.101c-22.939 73.2 37.585 157.335 135.185 187.921Z"
      />
    </g>
  </svg>
);

export default BgOrbitalPattern;
